import { FINISH_LOADING, START_LOADING } from '../types/loading';

export const startLoading = () => {
  return {
    type: START_LOADING,
  };
};

export const finishLoading = () => {
  return {
    type: FINISH_LOADING,
  };
};
